export default "__VITE_ASSET__Bjy7e6lC__"